module.exports = __webpack_public_path__ + "static/media/close-big-icon.47508035.svg";